const AppBar = {
  options: {
    customization: {
      items: {
        type: 'DraggableList',
        data: {
          internalLinking: true,
          textEditable: true,
        },
        order: 7,
      },
      items_2: {
        type: 'DraggableList',
        data: {
          internalLinking: true,
          textEditable: true,
        },
        order: 7,
      },
      items_4: {
        type: 'DraggableList',
        data: {
          internalLinking: true,
          textEditable: true,
        },
        order: 7,
      },
      items_7: {
        type: 'DraggableList',
        data: {
          internalLinking: true,
          textEditable: true,
        },
        order: 9,
      },
      buttonSelector: {
        type: 'DraggableList',
        data: {
          internalLinking: true,
          textEditable: true,
        },
        order: 9,
      },
      isStickyHeader: {
        type: 'Radio',
        order: 0,
        data: {
          direction: 'row',
          radioOptions: ['show', 'notShow'],
        },
      },
      logoPosition: {
        type: 'LeftCenterRight',
        order: 1,
      },
      textColor: {
        type: 'HexColor',
        order: 2,
      },

      bottomRadius: {
        type: 'RangePx',
        data: {
          max: 10,
          min: 0,
          step: 1,
        },
        order: 9,
      },
      backgroundColor: {
        type: 'HexColor',
        order: 10,
      },
      buttonIconColor: {
        type: 'HexColor',
        order: 11,
      },
      buttonSize: {
        type: 'RangePx',
        data: {
          max: 25,
          min: 0,
          step: 1,
        },
        order: 12,
      },
    },
    widgets: {
      AppBar_SearchAreaSettings: {
        type: 'Menu',
        order: 100,
        renderOptions: {
          controlKey: 'AppBar_SearchAreaSettings',
        },
        options: {
          searchBarPlaceholder: {
            type: 'Text',
            order: 0,
          },
          searchBarTextColor: {
            type: 'HexColor',
            order: 1,
          },
          searchBarTextSize: {
            order: 2,
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
          },
          searchBarTextStyle: {
            type: 'SelectBox',
            data: {
              selectOptions: ['normal', 'italic'],
            },
            order: 3,
          },
          searchBarTextWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 4,
          },
          searchBarIconAlignment: {
            type: 'SelectBox',
            data: {
              selectOptions: ['left', 'right'],
            },
            order: 5,
          },
          searchBarBorderColor: {
            type: 'HexColor',
            order: 6,
          },
          searchBarBackgroundColor: {
            type: 'HexColor',
            order: 7,
          },
          searchBarBorderRadius: {
            data: {
              max: 30,
              min: 0,
              step: 1,
              svgType: 'border',
            },
            type: 'FourPx',
          },
          padding: {
            type: 'FourPx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 9,
          },
          searchBarIconColor: {
            type: 'HexColor',
            order: 10,
          },
          searchBarIconSize: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 11,
          },
          searchBarIconBackgroundColor: {
            type: 'HexColor',
            order: 12,
          },
        },
      },
    },
  },
  variants: [
    {
      id: 'AppBar_1',
      name: 'AppBar_1',
      type: 'AppBar',
      data: {
        text: '',
        images: [],
      },
      customization: {
        items: [
          {
            id: '1',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710502620_390955c8-6515-4f4e-81cd-25f109e54014.png',
            name: 'setss',
            image: {
              text: 'setss',
            },
            pointTo: {
              pointTo: 'BeforeSearch',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
          },
          {
            id: '2',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/svg/1710504616_0086c4a0-6960-4436-993e-1333b27fa89a.svg',
            name: 'Notification',
            image: {
              text: 'Notification',
            },
            pointTo: {
              pointTo: 'Notification',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
          },
          {
            id: 'logo',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/mobligo/mobligo_new.f1a0e145b0fcc9ce50bd.png',
            name: 'logo',
            image: {
              text: 'Logo',
            },
            pointTo: {
              pointTo: 'Main',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
          },
        ],
        isStickyHeader: 'show',
        textColor: '#000000',
        bottomRadius: '0px',
        logoPosition: 'left',
        backgroundColor: '#5e30eb',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/appBar_0.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'AppBar_2',
      name: 'AppBar_2',
      type: 'AppBar',
      data: {
        searchBarPlaceholder: 'Marka veya ürün arayın',
        images: [],
      },
      customization: {
        items_2: [
          {
            id: '1',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710502620_390955c8-6515-4f4e-81cd-25f109e54014.png',
            name: 'setss',
            image: {
              text: 'setss',
            },
            pointTo: {
              pointTo: 'BeforeSearch',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
          },
          {
            id: '2',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/svg/1710504616_0086c4a0-6960-4436-993e-1333b27fa89a.svg',
            name: 'Notification',
            image: {
              text: 'Notification',
            },
            pointTo: {
              pointTo: 'Notification',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
          },
        ],
        isStickyHeader: 'show',
        textColor: '#000000',
        backgroundColor: '#5e30eb',
        searchBarTextColor: '#a6a6a6',
        searchBarTextSize: '12px',
        searchBarTextStyle: 'normal',
        searchBarTextWeight: '400',
        searchBarIconAlignment: 'right',
        searchBarBorderColor: '#F0F4FF',
        searchBarBackgroundColor: '#F0F4FF',
        searchBarBorderRadius: '5px 5px 5px 5px',
        padding: '7px 7px 7px 7px',
        searchBarIconColor: '#000000',
        searchBarIconSize: '20px',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/appbar_2_placeholder.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'AppBar_3',
      name: 'AppBar_3',
      type: 'AppBar',
      data: {
        text: '',
        images: [],
      },
      customization: {
        items: [
          {
            id: '1',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710502620_390955c8-6515-4f4e-81cd-25f109e54014.png',
            name: 'setss',
            image: {
              text: 'setss',
            },
            pointTo: {
              pointTo: 'BeforeSearch',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
          },
          {
            id: '2',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/svg/1710504616_0086c4a0-6960-4436-993e-1333b27fa89a.svg',
            name: 'Notification',
            image: {
              text: 'Notification',
            },
            pointTo: {
              pointTo: 'Notification',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
          },
          {
            id: 'logo',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/mobligo/mobligo_new.f1a0e145b0fcc9ce50bd.png',
            name: 'logo',
            image: {
              text: 'Logo',
            },
            pointTo: {
              pointTo: 'Main',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
          },
        ],
        isStickyHeader: 'show',
        textColor: '#000000',
        bottomRadius: '0px',
        logoPosition: 'left',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/appBar_3.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'AppBar_4',
      name: 'AppBar_4',
      type: 'AppBar',
      data: {
        text: '',
        images: [],
      },
      customization: {
        items_4: [
          {
            id: '1',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710505052_36056614-4a23-40d9-a469-21a4f6d30cf6.png',
            name: 'Categories',
            image: {
              text: 'Categories',
            },
            pointTo: {
              pointTo: 'Categories',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
          },
          {
            id: 'logo',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/mobligo/mobligo_new.f1a0e145b0fcc9ce50bd.png',
            name: 'logo',
            image: {
              text: 'Logo',
            },
            pointTo: {
              pointTo: 'Main',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
          },
          {
            id: '2',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005132094.png',
            name: 'BeforeSearch',
            image: {
              text: 'BeforeSearch',
            },
            pointTo: {
              pointTo: 'BeforeSearch',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
          },
          {
            id: '3',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706004697300.png',
            name: 'Profile',
            image: {
              text: 'Profile',
            },
            pointTo: {
              pointTo: 'Profile',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
          },
          {
            id: '4',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005430942.png',
            name: 'Cart',
            image: {
              text: 'Cart',
            },
            pointTo: {
              pointTo: 'Cart',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
          },
        ],
        isStickyHeader: 'show',
        textColor: '#000000',
        bottomRadius: '0px',
        logoPosition: 'left',
        backgroundColor: '#5e30eb',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/appBar_0.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'AppBar_5',
      name: 'AppBar_5',
      type: 'AppBar',
      data: {
        searchBarPlaceholder: 'Ara',
        images: [],
      },
      customization: {
        items_4: [
          {
            id: '1',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710505052_36056614-4a23-40d9-a469-21a4f6d30cf6.png',
            name: 'Categories',
            image: {
              text: 'Categories',
            },
            pointTo: {
              pointTo: 'Categories',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
          },
          {
            id: 'logo',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/mobligo/mobligo_new.f1a0e145b0fcc9ce50bd.png',
            name: 'logo',
            image: {
              text: 'Logo',
            },
            pointTo: {
              pointTo: 'Main',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
          },
          {
            id: '2',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005132094.png',
            name: 'BeforeSearch',
            image: {
              text: 'BeforeSearch',
            },
            pointTo: {
              pointTo: 'BeforeSearch',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
          },
          {
            id: '3',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706004697300.png',
            name: 'Profile',
            image: {
              text: 'Profile',
            },
            pointTo: {
              pointTo: 'Profile',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
          },
          {
            id: '4',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005430942.png',
            name: 'Cart',
            image: {
              text: 'Cart',
            },
            pointTo: {
              pointTo: 'Cart',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
          },
        ],
        isStickyHeader: 'show',
        textColor: '#FFFFFF',
        bottomRadius: '0px',
        logoPosition: 'left',
        searchBarTextColor: '#a6a6a6',
        searchBarTextSize: '12px',
        searchBarTextStyle: 'normal',
        searchBarTextWeight: '400',
        searchBarBorderColor: '#FFFFFF',
        searchBarBorderRadius: '20px 20px 20px 20px',
        padding: '6px 6px 6px 6px',
        searchBarIconColor: '#FFFFFF',
        searchBarIconSize: '20px',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/appBar_0.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'AppBar_6',
      name: 'AppBar_6',
      type: 'AppBar',
      data: {
        searchBarPlaceholder: 'Ürün, kategori veya marka ara.',
        images: [],
      },
      customization: {
        items_4: [
          {
            id: '1',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710505052_36056614-4a23-40d9-a469-21a4f6d30cf6.png',
            name: 'Categories',
            image: {
              text: 'Categories',
            },
            pointTo: {
              pointTo: 'Categories',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
          },
          {
            id: '2',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005132094.png',
            name: 'BeforeSearch',
            image: {
              text: 'BeforeSearch',
            },
            pointTo: {
              pointTo: 'BeforeSearch',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
          },
          {
            id: 'logo',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/mobligo/mobligo_new.f1a0e145b0fcc9ce50bd.png',
            name: 'logo',
            image: {
              text: 'Logo',
            },
            pointTo: {
              pointTo: 'Main',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
          },
          {
            id: '3',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706004697300.png',
            name: 'Profile',
            image: {
              text: 'Profile',
            },
            pointTo: {
              pointTo: 'Profile',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
          },
          {
            id: '4',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005430942.png',
            name: 'Cart',
            image: {
              text: 'Cart',
            },
            pointTo: {
              pointTo: 'Cart',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
          },
        ],
        logoPosition: 'left',
        isStickyHeader: 'show',
        textColor: '#000000',
        textBackgroundColor: '#FBC423',
        backgroundColor: '#5e30eb',
        searchBarTextColor: '#a6a6a6',
        searchBarTextSize: '12px',
        searchBarTextStyle: 'normal',
        searchBarTextWeight: '400',
        searchBarIconAlignment: 'right',
        searchBarBorderColor: '#F5F5F5',
        searchBarBackgroundColor: '#F5F5F5',
        searchBarBorderRadius: '30px 30px 30px 30px',
        padding: '5px 10px 5px 10px',
        searchBarIconColor: '#000000',
        searchBarIconSize: '20px',
        buttonSize: '16px',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/appBar_0.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'AppBar_HicretKuruyemis',
      name: 'AppBar_HicretKuruyemis',
      type: 'AppBar',
      data: {},
      customization: {},
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Appbar_7.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'AppBar_7',
      name: 'AppBar_7',
      type: 'AppBar',
      data: {
        searchBarPlaceholder: 'Ara',
        images: [],
      },
      customization: {
        items_4: [
          {
            id: '1',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710505052_36056614-4a23-40d9-a469-21a4f6d30cf6.png',
            name: 'Categories',
            image: {
              text: 'Categories',
            },
            pointTo: {
              pointTo: 'Categories',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
          },
          {
            id: 'logo',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/mobligo/mobligo_new.f1a0e145b0fcc9ce50bd.png',
            name: 'logo',
            image: {
              text: 'Logo',
            },
            pointTo: {
              pointTo: 'Main',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
          },
          {
            id: '2',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005132094.png',
            name: 'BeforeSearch',
            image: {
              text: 'BeforeSearch',
            },
            pointTo: {
              pointTo: 'BeforeSearch',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
          },
          {
            id: '3',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706004697300.png',
            name: 'Profile',
            image: {
              text: 'Profile',
            },
            pointTo: {
              pointTo: 'Profile',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
          },
          {
            id: '4',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005430942.png',
            name: 'Cart',
            image: {
              text: 'Cart',
            },
            pointTo: {
              pointTo: 'Cart',
              pointToType: 'defaultPage',
            },
            internalLinking: true,
          },
        ],
        isStickyHeader: 'show',
        textColor: '#000000',
        bottomRadius: '0px',
        logoPosition: 'left',
        backgroundColor: '#5e30eb',
        searchBarTextColor: '#000000',
        searchBarTextSize: '12px',
        searchBarTextStyle: 'normal',
        searchBarTextWeight: '400',
        searchBarBorderColor: '#FFFFFF',
        searchBarBorderRadius: '20px 20px 20px 20px',
        padding: '6px 6px 6px 6px',
        searchBarIconColor: '#000000',
        searchBarIconSize: '20px',
        searchBarBackgroundColor: '#F0F4FF',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/appBar_0.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'AppBar_HicretKuruyemis_2',
      name: 'AppBar_HicretKuruyemis_2',
      type: 'AppBar',
      data: {},
      customization: {},
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/appBar_0.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'AppBar_Petzzshop',
      name: 'AppBar_Petzzshop',
      type: 'AppBar',
      data: {},
      customization: {},
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/appBar_0.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'AppBar_Yenir',
      name: 'AppBar_Yenir',
      type: 'AppBar',
      data: {},
      customization: {},
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/appBar_0.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
  ],
};

export default AppBar;
